import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import DetailsPopoverBulletPoint from 'automation-ui-action-features/action-details/DetailsPopoverBulletPoint';
import ActionIcon from 'automation-ui-flow-core/canvas/ActionIcon';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Section } from 'foundations-components/transitional/components/Section';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_CONTENT_HEIGHT = 500;
const ScrollContentContainer = styled.div.withConfig({
  displayName: "DetailsPopoverContent__ScrollContentContainer",
  componentId: "kus4tx-0"
})(["*{z-index:0;}"]);
export default function DetailsPopoverContent({
  children,
  headerIconName,
  headerIconUrl,
  headerTitle,
  statusColor,
  statusIcon,
  statusText,
  theme
}) {
  return /*#__PURE__*/_jsxs("div", {
    onClick: event => {
      event.stopPropagation();
    },
    children: [/*#__PURE__*/_jsx(Section, {
      marginBlock: "0",
      paddingBlock: "400",
      paddingInline: "300",
      children: /*#__PURE__*/_jsx(UIMediaObject, {
        align: "baseline",
        itemLeft: /*#__PURE__*/_jsx(ActionIcon, {
          use: theme,
          name: headerIconName,
          src: headerIconUrl,
          size: 16
        }),
        children: /*#__PURE__*/_jsx(Text, {
          as: "h5",
          children: headerTitle
        })
      })
    }), /*#__PURE__*/_jsx(UIScrollContainer, {
      maxHeight: MAX_CONTENT_HEIGHT,
      scrollDirection: "vertical",
      children: /*#__PURE__*/_jsxs(View, {
        paddingInline: "300",
        paddingBlockEnd: "400",
        as: "div",
        children: [/*#__PURE__*/_jsx(DetailsPopoverBulletPoint, {
          iconName: statusIcon,
          iconColor: statusColor,
          children: statusText
        }), /*#__PURE__*/_jsx(ScrollContentContainer, {
          children: children
        })]
      })
    })]
  });
}